export default __webpack_public_path__ + "static/media/1.ab82d719.txt";